<template>
    <div>
        <!-- DIALOGO PARA ERRORES -->
        <div class="p-d-flex">
            <Toast />
        </div>
        <!-- NUEVO CONCEPTO -->
        <Dialog :visible.sync="dialogoConcepto" :closeOnEscape="true" :closable="false" :style="{ width: '90vw' }">
            <Concepto @closeConcepto="closeDialogConcepto()"></Concepto>
        </Dialog>
        <!-- DIALOGO DE LOADING -->
        <Dialog :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }" :modal="true">
            <span>{{ loadingMensaje }}</span>
            <ProgressBar mode="indeterminate" style="height: .5em" />
        </Dialog>
        <!-- DIALOG PARA ELIMINAR CONCEPTOS -->
        <Dialog :visible.sync="dialogDelete" :styles="{ width: '450px' }" :modal="true" :closeOnEscape="true"
            :closable="false">
            <div class="flex justify-content-between flex-wrap pb-2">
                <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-outlined"
                    @click="dialogDelete = false" />
                Eliminar
                <Button icon="pi pi-check" class="p-button-rounded p-button-success p-button-outlined"
                    @click="confirmDelete()" />
            </div>
            <hr size=7 color="#ED6421">
            <br>
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                <span v-if="editedConcepto">Esta seguro de borrar el concepto
                    <b>{{ editedConcepto.noIdentificacion }} | </b>
                    <b>{{ editedConcepto.descripcion }}</b>?</span>
            </div>
        </Dialog>
        <!-- LISTA DE CONCEPTOS -->
        <Card>
            <template #title>
                <div class="text-left p-d-flex justify-center p-fluid grid formgrid">
                    <div class="mt-0 ml-0 mr-0 mb-0 pt-0 pl-3 pr-0 pb-0 pa-0 justify-right field col-6 md:col-6">
                        Conceptos
                    </div>
                    <div
                        class="mt-0 ml-0 mr-0 mb-0 pt-0 pl-0 pr-5 pb-0 pa-0 text-right justify-right field col-6 md:col-6">
                        <Button icon="pi pi-plus" @click="nuevoConcepto()" class="mr-3 p-button-rounded" />
                        <Button icon="pi pi-undo" @click="getConceptos()" class="p-button-rounded" />
                    </div>
                </div>
            </template>
            <template #content>
                <DataTable :scrollable="true" scrollHeight="500px" class="p-datatable-sm"
                    :filters.sync="filtrosConceptos" removableSort showGridlines ref="conceptos" :value="itemsConceptos"
                    responsiveLayout="scroll" :paginator="true" :rows="10"
                    :globalFilterFields="['claveProdServ.clave', 'noIdentificacion', 'claveUnidad.clave', 'unidad', 'descripcion']"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Conceptos"
                    :loading="loadingItemsConceptos">
                    <template #header>
                        <div class="flex justify-content-between">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="filtrosConceptos['global'].value" placeholder="Buscar" />
                            </span>
                        </div>
                    </template>
                    <Column sortable field="noIdentificacion" header="No. Indentificación"
                        :bodyStyle="{ 'text-align': 'center', overflow: 'visible' }">
                        <template #body="{ data }">
                            {{ data.noIdentificacion }}
                        </template>
                        <template #filter="{ filterModel }">
                            <InputText type="text" v-model="filterModel.value" class="p-column-filter" />
                        </template>
                    </Column>
                    <Column sortable field="descripcion" header="Descripción"
                        :bodyStyle="{ 'text-align': 'left', overflow: 'visible' }">
                        <template #body="{ data }">
                            {{ data.descripcion }}
                        </template>
                        <template #filter="{ filterModel }">
                            <InputText type="text" v-model="filterModel.value" class="p-column-filter" />
                        </template>
                    </Column>
                    <Column sortable field="claveProdServ" header="Clave Producto Servicio"
                        :bodyStyle="{ 'text-align': 'center', overflow: 'visible' }">
                        <template #body="{ data }">
                            {{ data.claveProdServ.clave }}
                        </template>
                        <template #filter="{ filterModel }">
                            <InputText type="text" v-model="filterModel.value" class="p-column-filter" />
                        </template>
                    </Column>
                    <Column sortable field="claveUnidad" header="Clave Unidad"
                        :bodyStyle="{ 'text-align': 'center', overflow: 'visible' }">
                        <template #body="{ data }">
                            {{ data.claveUnidad.clave }}
                        </template>
                        <template #filter="{ filterModel }">
                            <InputText type="text" v-model="filterModel.value" class="p-column-filter" />
                        </template>
                    </Column>
                    <Column sortable field="unidad" header="Unidad"
                        :bodyStyle="{ 'text-align': 'center', overflow: 'visible' }">
                        <template #body="{ data }">
                            {{ data.unidad }}
                        </template>
                        <template #filter="{ filterModel }">
                            <InputText type="text" v-model="filterModel.value" class="p-column-filter" />
                        </template>
                    </Column>

                    <Column :exportable="false" :styles="{ 'min-width': '8rem' }"
                        :bodyStyle="{ 'text-align': 'center', overflow: 'visible' }">
                        <template #body="slotProps">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                                @click="editConcepto(slotProps.data)" v-tooltip.bottom="'Editar'" />
                            <Button icon="pi pi-trash" class="p-button-rounded p-button-danger"
                                @click="openDialogDelete(slotProps.data)" v-tooltip.bottom="'Eliminar'" />
                        </template>
                    </Column>
                </DataTable>
            </template>
        </Card>
    </div>
</template>
<script>
import axios from 'axios'
import { FilterMatchMode, FilterOperator } from 'primevue/api/';
import Concepto from './Concepto.vue';

export default {
    data() {
        return {
            loadingMensaje: "",
            loading: false,
            filtrosConceptos: {
                "global": { value: null, matchMode: FilterMatchMode.CONTAINS },
                "claveProdServ.clave": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                "noIdentificacion": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                "claveUnidad.clave": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                "unidad": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                "descripcion": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            },
            dialogoConcepto: false,

            dialogDelete: false,
            editedIndexConcepto: -1,
            editedConcepto: {},

            loadingItemsConceptos: false,
        };
    },
    computed: {
        itemsConceptos() {
            return this.$store.state.listaConceptosStore
        },
        empresa() {
            return this.$store.state.usuario;
        },
    },
    created() {
        this.getConceptos();
    },
    methods: {
        nuevoConcepto() {
            if (this.$store.state.conceptoStore.idConcepto != 0) {
                let conceptoDefault = {
                    idDocumento: 0,
                    idConcepto: 0,
                    claveProdServ: {
                        claveProdServ: '',
                    },
                    noIdentificacion: '',
                    claveUnidad: {
                        claveUnidad: '',
                    },
                    unidad: '',
                    descripcion: '',
                    valorUnitario: 0,
                    importe: 0,
                    descuento: 0,
                    precio: 0,
                    total: 0,
                    objImp: {},
                    impuestos: {
                        traslados: [],
                        retenciones: [],
                    },
                    numeroCuentaPredial: '',
                    material: '',
                    imagen: {
                        base64: '',
                    },
                    linea: '',
                    marca: '',
                    submarca: '',
                    iepsGas: 0,
                    almacenable: 'NO',
                    estatus: '',
                    usuarioCreador: '',
                    usuarioModificador: '',
                }
                this.$store.state.conceptoStore = { ...conceptoDefault }
            }
            this.dialogoConcepto = true
        },

        editConcepto(item) {
            this.$store.state.conceptoStore = { ...item };
            this.dialogoConcepto = true
        },

        async getConceptos() {
            try {
                this.loadingItemsConceptos = true;
                let response = await axios.get('Conceptos/GetConceptos/' + this.empresa.empresaBase)
                this.$store.state.listaConceptosStore = response.data
                this.loadingItemsConceptos = false;
            } catch (error) {
                this.loadingItemsConceptos = false;
                console.log(error)
            }
        },

        closeDialogConcepto() {
            this.dialogoConcepto = false;
        },

        openDialogDelete(item) {
            this.editedIndexConcepto = this.itemsConceptos.indexOf(item)
            this.editedConcepto = { ...item };
            this.dialogDelete = true;
        },

        async confirmDelete() {
            this.loading = true;
            this.loadingMensaje = 'Procesando soliciud, espere...'
            try {
                console.log(this.empresa)
                this.editedConcepto.usuarioModificador = this.empresa.nombre
                let response = await axios.put('Conceptos/PutConceptoEstatus/' + this.empresa.empresaBase, this.editedConcepto)
                this.itemsConceptos.splice(this.editedIndexConcepto, 1)
                this.dialogDelete = false;
                this.loading = false;
                this.$toast.add({ severity: 'success', detail: 'Concepto eliminado con éxito.', life: 3000 });

            } catch (error) {
                console.log(error)
                this.$toast.add({ severity: 'error', detail: 'Error al eliminar, intente nuevamente.', life: 3000 });
                this.loading = false;
            }
        },

    },
    components: { Concepto }
}
</script>